/* Minimal ZIP writer — STORE method (no compression).
 * Images are already compressed (PNG/JPEG/WebP) so STORE is efficient. */
function crc32(data) {
  var crc = 0xFFFFFFFF;
  for (var i = 0; i < data.length; i++) {
    crc ^= data[i];
    for (var j = 0; j < 8; j++) {
      crc = (crc >>> 1) ^ (crc & 1 ? 0xEDB88320 : 0);
    }
  }
  return (crc ^ 0xFFFFFFFF) >>> 0;
}

export function createZip(files) {
  /* files: Array<{name: string, data: ArrayBuffer}> */
  var encoder = new TextEncoder();
  var entries = files.map(function(f) {
    var nameBytes = encoder.encode(f.name);
    var data = new Uint8Array(f.data);
    return { nameBytes: nameBytes, data: data, crc: crc32(data) };
  });

  /* Calculate offsets */
  var localOffsets = [];
  var offset = 0;
  entries.forEach(function(e) {
    localOffsets.push(offset);
    offset += 30 + e.nameBytes.length + e.data.length;
  });

  var centralDirStart = offset;
  var dirSize = 0;
  entries.forEach(function(e) { dirSize += 46 + e.nameBytes.length; });
  var totalSize = centralDirStart + dirSize + 22;

  var buf = new ArrayBuffer(totalSize);
  var u8 = new Uint8Array(buf);
  var dv = new DataView(buf);
  offset = 0;

  /* Local file entries */
  entries.forEach(function(e) {
    dv.setUint32(offset, 0x04034b50, true); offset += 4; /* signature */
    dv.setUint16(offset, 20, true); offset += 2;  /* version needed */
    dv.setUint16(offset, 0, true); offset += 2;   /* bit flag */
    dv.setUint16(offset, 0, true); offset += 2;   /* STORE */
    dv.setUint16(offset, 0, true); offset += 2;   /* mod time */
    dv.setUint16(offset, 0, true); offset += 2;   /* mod date */
    dv.setUint32(offset, e.crc, true); offset += 4;
    dv.setUint32(offset, e.data.length, true); offset += 4; /* comp size */
    dv.setUint32(offset, e.data.length, true); offset += 4; /* uncomp size */
    dv.setUint16(offset, e.nameBytes.length, true); offset += 2;
    dv.setUint16(offset, 0, true); offset += 2;   /* extra field len */
    u8.set(e.nameBytes, offset); offset += e.nameBytes.length;
    u8.set(e.data, offset); offset += e.data.length;
  });

  /* Central directory */
  entries.forEach(function(e, i) {
    dv.setUint32(offset, 0x02014b50, true); offset += 4; /* signature */
    dv.setUint16(offset, 20, true); offset += 2;  /* version made by */
    dv.setUint16(offset, 20, true); offset += 2;
    dv.setUint16(offset, 0, true); offset += 2;
    dv.setUint16(offset, 0, true); offset += 2;
    dv.setUint16(offset, 0, true); offset += 2;
    dv.setUint16(offset, 0, true); offset += 2;
    dv.setUint32(offset, e.crc, true); offset += 4;
    dv.setUint32(offset, e.data.length, true); offset += 4;
    dv.setUint32(offset, e.data.length, true); offset += 4;
    dv.setUint16(offset, e.nameBytes.length, true); offset += 2;
    dv.setUint16(offset, 0, true); offset += 2;
    dv.setUint16(offset, 0, true); offset += 2;
    dv.setUint16(offset, 0, true); offset += 2;
    dv.setUint16(offset, 0, true); offset += 2;
    dv.setUint32(offset, 0, true); offset += 4;    /* ext attrs */
    dv.setUint32(offset, localOffsets[i], true); offset += 4; /* local header offset */
    u8.set(e.nameBytes, offset); offset += e.nameBytes.length;
  });

  /* End of central directory */
  dv.setUint32(offset, 0x06054b50, true); offset += 4;
  dv.setUint16(offset, 0, true); offset += 2;
  dv.setUint16(offset, 0, true); offset += 2;
  dv.setUint16(offset, entries.length, true); offset += 2;
  dv.setUint16(offset, entries.length, true); offset += 2;
  dv.setUint32(offset, dirSize, true); offset += 4;
  dv.setUint32(offset, centralDirStart, true); offset += 4;
  dv.setUint16(offset, 0, true); offset += 2;     /* comment len */

  return new Blob([buf], { type: 'application/zip' });
}
